import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { InteserraResourcesModel } from 'src/Models/InteserraResourcesModel';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { I360Service } from 'src/Services/i360Service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import * as DOMPurify from 'dompurify';

declare var $: any;

@Component({
  selector: 'app-inteserra-resources',
  templateUrl: './inteserra-resources.component.html',
  styleUrls: ['./inteserra-resources.component.css']
})
export class InteserraResourcesComponent implements OnInit, AfterViewInit, OnDestroy {

  listOfInteserraResources: InteserraResourcesModel[];
  filterModel = new FilterModel();
  tokenKey: string = '';
  _userID: any;

  currentPage: number = 1;
  totalRecordCount: number = -1;
  keywordFilter: string = '';
  OrderBy: string = '';
  isAscending: boolean = false
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  videoURL: any;
  videoType: string;
  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  @ViewChild("videoModel", { static: false }) videoModel: ElementRef;
  @ViewChild("resourcesVideoModal", { static: false }) resourcesVideoModal: ElementRef;
  topicTitle: string = ''
  isEmbed: boolean = false;
  isloading: boolean = false;

  constructor(private readonly i360Service: I360Service,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly appActivity: ApplicationActivityService,
    private readonly sanitizer: DomSanitizer,
    private readonly ngZone: NgZone) {
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));
    this._userID = sessionStorage.getItem('UserId');
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.listOfInteserraResources = [];
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
    this.videoType = '';
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'SortOrder';
    this.filterModel.userID = this._userID;
    this.filterModel.productId = ToolEnum.JSIResources;
    this.titleService.setTitle('JSI Resources | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.Geti360InteserraResources();
  }

  ngAfterViewInit() {
    $(this.resourcesVideoModal.nativeElement).on('hidden.bs.modal.inteserraResources', () => {
      this.ngZone.run(() => this.unloadVideoPlayer());
    });
  }

  ngOnDestroy() {
    if (this.resourcesVideoModal && this.resourcesVideoModal.nativeElement) {
      $(this.resourcesVideoModal.nativeElement).off('hidden.bs.modal.inteserraResources');
    }
  }

  Geti360InteserraResources() {
    this.isloading = true;
    this.i360Service.i360InteserraResourcesGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        this.listOfInteserraResources = data['listOfInteserraResources'];
        if (this.listOfInteserraResources != null) {
          if (this.listOfInteserraResources.length > 0) {
            this.totalRecordCount = this.listOfInteserraResources[0].totalRecordCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
        else {
          this.totalRecordCount = 0;
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  donwloadFile(data: InteserraResourcesModel) {
    this.topicTitle = '';
    this.isEmbed = data.isEmbed;
    if (data.isLocked)
      return;

    this.topicTitle = data.title;

    if (data.linktype == 1 || data.linktype == 0) {
      ApplicationActivityStore('View', 'JSI360 Resources', this.appActivity, data.resourcesId, ActionActivity['JSI360 Resources'], data.title);
      if (data.externalURL.includes('youtube')) {
        this.videoURL = data.externalURL;
        const cleanURL = DOMPurify.sanitize(data.externalURL);
        this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(cleanURL);
        this.videoModel.nativeElement.click();
      }
      else {
        window.open(data.externalURL, '_blank');
      }
    }
    else if (data.linktype == 2) {
      const extension = data.docPath.split(".").pop();
      if (extension == 'ogg' || extension == 'ogv' || extension == 'mp4' || extension == 'webm') {
        ApplicationActivityStore('View', 'JSI360 Resources', this.appActivity, data.resourcesId, ActionActivity['JSI360 Resources'], data.title);
        this.videoType = 'video/' + extension;
        const cleanURL = DOMPurify.sanitize(data.docPath);
        this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(cleanURL);
        this.videoModel.nativeElement.click();
        const player = this.videoplayer ? this.videoplayer.nativeElement : null;
        if (player && typeof player.load === 'function') {
          player.load();
          player.play();
        }
      }
      else {
        ApplicationActivityStore('Download', 'JSI360 Resources', this.appActivity, data.resourcesId, ActionActivity['JSI360 Resources'], data.displayDocName);
        this.isShowprogressSpinner = true;
        this.blockedDocument = true;
        this.i360Service.DownloadDocument(this.tokenKey, { DocType: 'Inteserra Resources', DocPath: data.docPath }).subscribe(
          fileData => {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
            if (fileData != null) {
              FileSaver.saveAs(fileData, data.displayDocName);
              this.toastr.success('File download successfully', 'File Downloaded')
            }
          }, error => {
            this.isShowprogressSpinner = false;
            this.blockedDocument = false;
            console.log(error);
          });
      }
    }
  }

  closeVideoPlayer() {
    this.unloadVideoPlayer();
  }

  private unloadVideoPlayer() {
    const player = this.videoplayer ? this.videoplayer.nativeElement : null;
    if (player && typeof player.pause === 'function') {
      player.pause();
      player.currentTime = 0;
    }
    this.videoURL = null;
    this.isEmbed = false;
  }

  toggleVideo(event: any) {
    var myVideo: any = this.videoplayer.nativeElement
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  pageChanged($event: any) {
    this.filterModel.pageNumber = $event.page;
    this.currentPage = $event.page;
    this.Geti360InteserraResources();
  }
}
